import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodOptionalDateRange } from 'routes/routeUtils';
import { manualValidationStatuses } from 'types/api/admin/labTrades';
import {
  masterTradeParticipationStatuses,
  participationValidationStatuses,
} from 'types/api/admin/trades_instances';
import z from 'zod';

export const adminManualValidationTradesRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/trades/manual_validation',
  validateSearch: z.object({
    tab: z.enum(manualValidationStatuses).default('to_be_treated'),
    page: z.number().default(1),
  }),
}).lazy(() =>
  import('pages/admin/ManualValidationTrades/TradesPage/TradesPage').then((d) => d.Route)
);

export const adminManualValidationTradesParticipationsRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/trades/manual_validation/$masterTradeId/participations',
  validateSearch: z.object({
    tab: z.enum(masterTradeParticipationStatuses).default('to_be_treated'),
    query: z.string().optional(),
    status: z.enum(participationValidationStatuses).optional(),
    transmittedAt: zodOptionalDateRange,
  }),
}).lazy(() =>
  import('pages/admin/ManualValidationTrades/ParticipationsPage/ParticipationsPage').then(
    (d) => d.Route
  )
);

export const adminManualValidationTradesValidationsRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/trades/manual_validation/validation',
  staticData: { fullScreen: true },
  validateSearch: z.object({
    participationIds: z.array(z.number()).default([]),
    currentParticipationIndex: z.number().default(0),
  }),
}).lazy(() =>
  import('pages/admin/ManualValidationTrades/ValidationsPage/ValidationsPage').then((d) => d.Route)
);
